import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/layout.vue'
import userLayout from '../components/userLayout.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: (resolve) => require(['../views/index.vue'], resolve),
    },
    {
        path: '/',
        component: Layout,
        children: [{
            path: '/apply',
            name: 'apply',
            component: (resolve) => require(['../views/apply.vue'], resolve),
        },
        {
            path: '/applyView',
            name: 'applyView',
            component: (resolve) => require(['../views/applyView.vue'], resolve),
        },
        {
            path: '/usercenter',
            name: 'usercenter',
            component: (resolve) => require(['../views/usercenter.vue'], resolve),
        },
        {
            path: '/stand/standList',
            name: 'standList',
            component: (resolve) => require(['../views/stand/standList.vue'], resolve),
        },
        {
            path: '/news/list',
            name: 'newsList',
            component: (resolve) => require(['../views/news/list.vue'], resolve),
        },
        {
            path: '/news/detail',
            name: 'newsDetail',
            component: (resolve) => require(['../views/news/detail.vue'], resolve),
        },
        {
            path: '/addFeedBack',
            name: 'addFeedBack',
            component: (resolve) => require(['../views/addFeedBack.vue'], resolve),
        },
        {
            path: '/companyinfo',
            name: 'companyinfo',
            component: (resolve) => require(['../views/companyinfo.vue'], resolve),
        },
        {
            path: '/objectView',
            name: 'objectView',
            component: (resolve) => require(['../views/objection/view.vue'], resolve),
        },
        {
            path: '/agentorg',
            name: 'agentorg',
            component: (resolve) => require(['../views/brand/agentorg.vue'], resolve),
        },
        ]
    },
    {
        path: '/usercenter',
        component: userLayout,
        children: [
            {
                path: 'applyHistory',
                name: 'applyHistory',
                component: (resolve) => require(['../views/userpage/applyHistory.vue'], resolve),
            },
            {
                path: 'objection',
                name: 'objection',
                component: (resolve) => require(['../views/userpage/objection.vue'], resolve),
            },
            {
                path: 'importantprojectManage',
                name: 'importantprojectManage',
                component: (resolve) => require(['../views/userpage/importantprojectManage.vue'], resolve),
            },
            {
                path: 'prizeManage',
                name: 'prizeManage',
                component: (resolve) => require(['../views/userpage/prizeManage.vue'], resolve),
            },
            {
                path: 'economicManage',
                name: 'economicManage',
                component: (resolve) => require(['../views/userpage/economicManage.vue'], resolve),
            },
            
            {
                path: 'brandManage',
                name: 'brandManage',
                component: (resolve) => require(['../views/userpage/brandManage.vue'], resolve),
            },
            {
                path: 'patentpoolManage',
                name: 'patentpoolManage',
                component: (resolve) => require(['../views/userpage/patentpoolManage.vue'], resolve),
            },
            {
                path: 'patenttransManage',
                name: 'patenttransManage',
                component: (resolve) => require(['../views/userpage/patenttransManage.vue'], resolve),
            },
        ]
    },

]

const router = new VueRouter({
    mode: 'history',
    base: '/jzz/',
    scrollBehavior: () => ({ y: 0 }),
    routes
})

export default router